import { trigger, animate, transition, style, state } from '@angular/animations';

export const expandRowAnimation =
    trigger('detailExpand', [
        state('collapsed', style({ height: '0', minHeight: '0', visibility: 'hidden' })),
        state('expanded', style({ height: '*', visibility: 'visible' })),
        transition('expanded <=> collapsed', animate('725ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]);
